// src/contexts/SectionContext.tsx
import React, { createContext, useContext, useState, ReactNode } from "react";

interface SectionContextType {
  selectedSection: string;
  setSelectedSection: (section: string) => void;
}

const SectionContext = createContext<SectionContextType | undefined>(undefined);

export const SectionProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [selectedSection, setSelectedSection] = useState<string>("Teleconsult");

  return (
    <SectionContext.Provider value={{ selectedSection, setSelectedSection }}>
      {children}
    </SectionContext.Provider>
  );
};

export const useSection = () => {
  const context = useContext(SectionContext);
  if (!context) {
    throw new Error("useSection must be used within a SectionProvider");
  }
  return context;
};
